import { useState } from 'react'
import PropTypes from 'prop-types'

const Tabs = ({
  tabs = [],
  size = 'default',
  disabled = false,
  additionalClass = '',
  onChange = () => {},
  ...props
}) => {
  const defaultTabIndex = tabs.findIndex((tab) => tab.default)
  const [activeTab, setActiveTab] = useState(defaultTabIndex === -1 ? 0 : defaultTabIndex)

  if (!tabs.length) {
    return null
  }

  const onTabClick = (tab, index) => {
    if (index !== activeTab) {
      setActiveTab(index)
      onChange(tab, index)
    }
  }

  return (
    <div className={`tabsV2 ${additionalClass}`} {...props}>
      <div className="tabsV2__header">
        {tabs.map((tab, index) => (
          <button
            type="button"
            key={index}
            className={`${size} ${index === activeTab ? 'active' : ''}`}
            onClick={() => onTabClick(tab, index)}
            disabled={disabled}
          >
            {tab.heading}
          </button>
        ))}
      </div>
      {tabs[activeTab] && tabs[activeTab].content ? (
        <div className="tabsV2__content">{tabs[activeTab].content}</div>
      ) : null}
    </div>
  )
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.node,
      default: PropTypes.bool,
    }),
  ),
  onChange: PropTypes.func,
  additionalClass: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  disabled: PropTypes.bool,
}

export default Tabs
